import React from 'react';
import {Button} from '@material-ui/core';

const Confirmation = ({children, onConfirmation, onCancellation}) => {
    return (
        <div role="dialog">
            <h1>Confirmation</h1>
            <div>{children}</div>
            <div className="buttons-container">
                <Button variant="contained" color="primary" onClick={onConfirmation}>
                    OK
                </Button>
                <Button variant="contained" color="secondary" onClick={onCancellation}>
                    Cancel
                </Button>
            </div>
        </div>
    );
};

export default Confirmation;
